export const SIGNIN = '/signin';
export const SIGNUP = '/signup';
export const FORGOT_PASSWORD = '/forgot-password';
export const LOCATION_INFO = '/location-info';
export const COUNTERS = '/counters';
export const COUNTER_INFO = '/counter-info';
export const OPTIONS = '/options';
export const MAIN = '/';
export const HISTORY_DASHBOARD = '/history-dashboard';
